import tapdencity1 from '../tapdensity/tapdencity1.png'

const tapdencityImagenes = [
    tapdencity1,

]

export default tapdencityImagenes